import i18next from 'i18next'
import { initReactI18next } from 'react-i18next'
import en from './locale/strings-en.json'
import es from './locale/strings-es.json'

const LANGUAGE_STORAGE_KEY = 'rapa_language'

const savedLanguage = localStorage.getItem(LANGUAGE_STORAGE_KEY) || 'en'

i18next.use(initReactI18next).init({
  lng: savedLanguage,
  debug: false,
  resources: {
    en: {
      translation: en,
    },
    es: {
      translation: es,
    },
  },
  interpolation: {
    escapeValue: false,
  },
})

export { LANGUAGE_STORAGE_KEY }
export default i18next
